export {};

declare global {
    interface Window {
        privacyManager?: PrivacyManager;
    }
}

/**
 * Handles the interaction of the privacy manager (cookie banner).
 *
 * This file is deliberately not called privacy-manager: ad blocker filter lists block a script
 * with that name, which leaves the banner visible but unable to close.
 */
class PrivacyManager {

    private readonly container: HTMLElement | null;

    /**
     * Constructs a new instance of the Privacy Manager.
     */
    constructor(elementId: string) {
        this.container = document.getElementById(elementId);

        if (!this.container) return;

        this.listenForInteraction();
    }

    private listenForInteraction() {
        this.container?.addEventListener('change', () => {
            const buttons = this.container?.querySelectorAll('[data-privacy-choice]') as NodeListOf<HTMLButtonElement>;

            if (!buttons)
                throw Error('The privacy option buttons can\'t be found in the privacy manager container.');

            for (const button of buttons) {
                const privacyOption = button.dataset.privacyChoice;

                button.dataset.display = privacyOption === 'customized' ? '' : 'none';
            }
        });
    }

    public setPrivacyChoices(data: object) {

        if (typeof gtag !== "undefined")
            gtag('consent', 'update', data);

        if (this.container)
            this.container.dataset.visibility = 'hidden';
    }
}

// Initialize the privacy manager
window.privacyManager = new PrivacyManager('privacy-manager');